console.log('DBCONFIG ', process.env.Default_Activity_ID);
console.log('DBCONFIG ', process.env.API_HOST);
console.log('DBCONFIG ', process.env.OSS_HOST);
const OSS = process.env.OSS_HOST;

export default {
  baseUrl: process.env.API_HOST,
  staticImgUrl: `${OSS}/static/img/certificates/`,
  staticAvatarUrl: `${OSS}/static/img/users/`,
  staticChatImageUrl: `${OSS}/static/img/chat/`,
  staticPostImageUrl: `${OSS}/static/img/post/`,
  staticGroupImageUrl: `${OSS}/static/img/groups/`,
  defaultActivityId: process.env.Default_Activity_ID
};
